var SAlvaro = /** @class */ (function () {
    function SAlvaro() {
    }
    SAlvaro.saludar = function () {
        alert('Holfffffffa');
    };
    return SAlvaro;
}());
export default SAlvaro;
